export default function phoneSlider() {

	if (document.querySelector('.phone-slider__slider.glide')) {
		var glide = new Glide('.phone-slider__slider.glide', {
			type: 'carousel',
			perView: 1,
			focusAt: 'center',
			gap: 0,
			autoplay: 5500
		})

		glide.mount()
	}

}
